var React = require('react');

function LineHero (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M36.1958 401.312C-37.0372 249.084 11.6958 79.3124 121.196 19.3124C246.696 -54.6876 538.196 111.812 584.696 229.312C659.734 418.924 121.196 578 36.1958 401.312Z","stroke":"#FEAC00","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M63.4999 414.5C-24.0001 270 82 201.5 191.5 141.5C322.5 69.7192 429 196 475.5 313.5C550.538 503.112 161.02 575.547 63.4999 414.5Z","stroke":"#FEAC00","strokeWidth":"2","key":1})]);
}

LineHero.defaultProps = {"width":"593","height":"505","viewBox":"0 0 593 505","fill":"none"};

module.exports = LineHero;

LineHero.default = LineHero;
